import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=f3d4e2fa&"
import script from "./ProductPage.vue?vue&type=script&lang=js&"
export * from "./ProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductHero: require('/vercel/path0/components/heros/ProductHero.vue').default,ComponentLoader: require('/vercel/path0/components/general/ComponentLoader.vue').default})
